import React from 'react';

// Refund Policy page - designed to set clear expectations without stating "no refunds"
const RefundPolicyPage = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1 className="privacy-title">Refund Policy</h1>

        <div className="privacy-content">
          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">1</span>
              <h2>Overview</h2>
            </div>
            <p>
              We want you to have a smooth experience with getphotoshoot.ai. If something doesn’t go as expected,
              our team will work with you to make it right — through troubleshooting, re-crediting your account,
              or where appropriate, issuing a refund to your original payment method.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">2</span>
              <h2>Eligibility Window</h2>
            </div>
            <p>
              Requests can be submitted within <strong>7 days</strong> of the original charge. Please contact us as soon as possible so we can help quickly.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">3</span>
              <h2>What We Typically Approve</h2>
            </div>
            <ul className="terms-list">
              <li>Duplicate charge or accidental multiple payments</li>
              <li>Unauthorized transaction (after reasonable verification)</li>
              <li>Technical issue resulting in <strong>no delivery</strong> or <strong>unusable output</strong> despite retry</li>
              <li>Payment processed, but credits not received and we’re unable to fix promptly</li>
            </ul>
            <p>
              In many cases, we may add or restore credits to your account immediately so you can continue without delay.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">4</span>
              <h2>Resolution Options</h2>
            </div>
            <ul className="terms-list">
              <li>Account credit equal to the affected amount</li>
              <li>Re-processing the generation(s) at no additional cost</li>
              <li>Refund to original payment method when appropriate</li>
            </ul>
            <p>
              Refunds, when issued, are returned to the original payment method and typically appear within
              <strong> 5–10 business days</strong>, depending on your bank or card issuer.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">5</span>
              <h2>How to Request Help</h2>
            </div>
            <p>Please include the following so we can resolve your case quickly:</p>
            <ul className="terms-list">
              <li>Registered email address</li>
              <li>Payment reference (last 4 digits, date/time, and amount)</li>
              <li>Short description of the issue and any relevant screenshots</li>
            </ul>
            <p>
              Contact: <a className="terms-link" href="mailto:success@getphotoshoot.ai">success@getphotoshoot.ai</a>
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">6</span>
              <h2>Fair Use Notes</h2>
            </div>
            <p>
              Because our product allocates compute and model time for each generation, outcomes that already
              consumed credits are generally resolved via <strong>additional credits</strong> or <strong>re-processing</strong> rather than monetary reimbursement. We’ll always aim for a fair outcome.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">7</span>
              <h2>Chargebacks</h2>
            </div>
            <p>
              If a chargeback is initiated while we’re actively assisting you, our ability to resolve the
              issue may be delayed. We encourage contacting us first so we can help quickly.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">8</span>
              <h2>We’re Here to Help</h2>
            </div>
            <p>
              If you ever feel something didn’t work as expected, reach out. Our goal is to ensure you’re satisfied
              with the service and the results you produce.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicyPage;


